var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('Main-section'),_c('HowItWorks'),_c('About-us'),_c('Services'),_c('Portfolio'),_c('Counts'),_c('Solutions-section'),_c('Parteners'),_c('News-letter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }